<template>
  <div class="mx-auto">

    <component v-for="block in blocks"
      :key="block.id"
      :is="`block-${block.type_of_block.toLowerCase().replace('_','-')}`"
      :block="block">
    </component>

    <pre v-if="debug">
      {{ blocks }}
    </pre>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BlockTitle from './blocks/title.vue'
import BlockText from './blocks/text.vue'
import BlockTitleText from './blocks/title_text.vue'
import BlockImage from './blocks/image.vue'
import BlockVideo from './blocks/video.vue'
import BlockTextImage from './blocks/text_image.vue'
import BlockSlider from './blocks/slider.vue'
import BlockQuiz from './blocks/quiz.vue'
import BlockQuizTest from './blocks/quiz_test.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  computed: {
    ...mapGetters(['subject_blocks']),
    blocks() {
      return this.subject_blocks(this.$route.params.id)
    }
  },
  components: {
    BlockTitle,
    BlockText,
    BlockTitleText,
    BlockTextImage,
    BlockImage,
    BlockVideo,
    BlockSlider,
    BlockQuiz,
    BlockQuizTest,
  }
}
</script>